import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  loanDurationInMonths,
  parseLoanStartDate,
} from '@app/dashboard/shared/fiscality-rent/fiscality-rent-format';

@Directive()
export abstract class EaOptimizationFiscalityRentFormBuilder extends PrFormAbstract {
  options: any;

  generate(entity: any, options: any) {
    this.options = options;
    return this.formBuilder.group(
      {
        propertyType: this.entity.propertyType ? entity.propertyType : null,
        propertyValue: [
          this.entity.propertyValue ? entity.propertyValue : null,
          Validators.required,
        ],
        purchasePrice: entity.purchasePrice ?? null,
        rent: [this.entity.rent ? entity.rent : null, Validators.required],
        furnitureValue: entity.furnitureValue ?? null,
        workAmount: entity.workAmount ?? null,
        fiscalityLawType: this.entity.fiscalityLawType
          ? entity.fiscalityLawType
          : null,
        cashOrCredit: [
          entity ? entity.cashOrCredit : null,
          [
            this.prFormService.RefreshEveryValidators([
              'loanDurationInMonths',
              'borrowedAmount',
              'loanInterestRate',
              'loanInsuranceRate',
            ]),
          ],
        ],
        loanDurationInMonths: [
          loanDurationInMonths(entity),
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('cashOrCredit', 'CREDIT')
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        borrowedAmount: [
          entity ? entity.borrowedAmount : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('cashOrCredit', 'CREDIT')
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        loanInterestRate: [
          entity.loanInterestRate
            ? this.formatNumber(entity.loanInterestRate * 100)
            : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('cashOrCredit', 'CREDIT')
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        loanInsuranceRate: [
          entity.loanInsuranceRate
            ? this.formatNumber(entity.loanInsuranceRate * 100)
            : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('cashOrCredit', 'CREDIT')
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        loanStartDate: [
          parseLoanStartDate(entity.loanStartDate),
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('cashOrCredit', 'CREDIT')
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        agencyFees: [entity.agencyFees ?? null, Validators.required],
        notaryFees: [
          entity.notaryFees != null
            ? this.formatNumber(entity.notaryFees * 100)
            : null,
          Validators.required,
        ],
        propertyTax: entity.propertyTax ?? null,
        otherFees: entity.otherFees ?? null,
      },
      options,
    );
  }

  formatNumber(value: number) {
    return Math.round(value * 100) / 100;
  }

  extract() {
    return {
      rentalId: this.entity?.rentalId ?? null,
      propertyType: this.emptyIsNull(this.form.value.propertyType),
      fiscalityLawType: this.emptyIsNull(this.form.value.fiscalityLawType),
      rent: this.emptyIsNull(this.form.value.rent),
      propertyValue: this.emptyIsNull(this.form.value.propertyValue),
      purchasePrice: this.emptyIsNull(this.form.value.purchasePrice),
      furnitureValue: this.emptyIsNull(this.form.value.furnitureValue),
      workAmount: this.emptyIsNull(this.form.value.workAmount),
      cashOrCredit: this.emptyIsNull(this.form.value.cashOrCredit),
      borrowedAmount: this.emptyIsNull(this.form.value.borrowedAmount),
      loanInterestRate: this.emptyIsNull(
        this.form.value.loanInterestRate / 100,
      ),
      loanInsuranceRate: this.emptyIsNull(
        this.form.value.loanInsuranceRate / 100,
      ),
      loanDurationInMonths: this.emptyIsNull(
        this.form.value.loanDurationInMonths,
      ),
      loanStartDate: this.form.value.loanStartDate
        ? new Date(this.form.value.loanStartDate).toISOString().split('.')[0] +
          'Z'
        : null,
      agencyFees: this.emptyIsNull(this.form.value.agencyFees),
      notaryFees: this.emptyIsNull(this.form.value.notaryFees / 100),
      propertyTax: this.emptyIsNull(this.form.value.propertyTax),
      otherFees: this.emptyIsNull(this.form.value.otherFees),
    };
  }
}
